
import Component from '../../../assets/scripts/modules/component'
// import fireCustomEvent from '../../../vendor/scripts/fabrique/modules/fire-custom-event'

class QuestionsComponent extends Component {
  init () {
    this.buttons = [...this.element.querySelectorAll('.questions__question')]
    this.regions = [...this.element.querySelectorAll('.questions__answer')]

    this.initButtons()
    this.buttonHandler(null, this.buttons[0])
    // this.listenForEvent()
  }

  initButtons () {
    this.buttons.forEach(button => button.addEventListener('click', event => this.buttonHandler(event, button)))
  }

  buttonHandler (event, currentButton) {
    const region = document.getElementById(currentButton.getAttribute('aria-controls'))

    if (!region) {
      return
    }

    if (currentButton.getAttribute('aria-expanded') === 'true') {
      this.toggleRegion(currentButton, region, true)
    } else {
      if (event) {
        this.buttons.forEach(button => button.getAttribute('aria-expanded') === 'true' && this.buttonHandler(null, button))
        // fireCustomEvent('questions__close-all')
      }

      this.toggleRegion(currentButton, region)
    }
  }

  toggleRegion (button, region, forceClose = false) {
    if (!region && !button) {
      return
    }

    region = region || document.getElementById(button.getAttribute('aria-controls'))
    button = button || document.querySelector(`[aria-controls="${region.id}"]`)

    if (!region || !button) {
      return
    }

    const focusableElements = [...region.querySelectorAll('a, button, input, select, textarea')]

    if (forceClose || button.getAttribute('aria-expanded') === 'true') {
      region.setAttribute('aria-hidden', true)
      button.setAttribute('aria-expanded', false)

      focusableElements.forEach(element => this.deactivateFocusableElement(element))
    } else {
      region.setAttribute('aria-hidden', false)
      button.setAttribute('aria-expanded', true)

      focusableElements.forEach(element => this.activateFocusableElement(element))
    }
  }

  deactivateFocusableElement (element) {
    const tabindex = element.getAttribute('tabindex')

    if (tabindex !== null) {
      element.setAttribute('data-tabindex', tabindex)
    }

    element.setAttribute('tabindex', -1)
  }

  activateFocusableElement (element) {
    const tabindex = element.getAttribute('data-tabindex')

    if (tabindex !== null) {
      element.setAttribute('tabindex', tabindex)
    } else {
      element.removeAttribute('tabindex')
    }

    element.removeAttribute('data-tabindex')
  }

  scrollToRegion (region) {
    if (!region) {
      return
    }

    const rect = region.getBoundingClientRect()
    window.scroll({ top: (window.pageYOffset + rect.top) - (window.innerHeight / 3), left: 0, behavior: 'smooth' })
  }

  // listenForEvent () {
  // Make sure to disable all the other items
  // window.addEventListener('questions__close-all', () => {
  //  this.buttons.forEach(button => button.getAttribute('aria-expanded') === 'true' && this.buttonHandler(null, button))
  // })
  // }
}

window.addEventListener('init-load', () => {
  for (const element of document.querySelectorAll('.questions')) {
    element.instance = element.instance || new QuestionsComponent(element)
  }
})
